import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Form, Table } from "semantic-ui-react";
import { CoverageProps, PortalType, QAPropsBase } from "../State";
import { store, handleErrorToast, entityChangeFn } from "../store";
import Question from "./Question";

// tslint:disable-next-line: interface-name
interface PCovState {
    results: PCovSearchResults;
    pageIndex: number;
    pageSize: number;
    coverageID?: number;
    isLoading: boolean;
}

interface PCovProps {
    onChange?: entityChangeFn;
    byCarrier?: boolean;
    propsBase: QAPropsBase;
}

// tslint:disable-next-line: interface-name
interface PCovSearchRecord {
    nameTabID: string;
    name: string;
    detail: string;
}

// tslint:disable-next-line: interface-name
interface PCovSearchResult {
    nameTabID: string;
    name: string;
    detail: string;
    data: PCovSearchRecord;
}

// tslint:disable-next-line: interface-name
interface PCovSearchResults {
    count: number;
    records: PCovSearchResult[];
}

// this is the same structure as the search results,
// but with properties specifically for DataTables for jQuery
// which is a frontend consumer of this web service
// tslint:disable-next-line: interface-name
interface PCovSearchResultsWrapped {
    recordsTotal: number;
    recordsFiltered: number;
    data: PCovSearchResult[];
}

// tslint:disable-next-line: interface-name
interface PCovSearchState {
    employerName: string;
    dateOfAccident: string;
}

// tslint:disable-next-line: one-variable-per-declaration
const PCovTable: React.FunctionComponent<PCovProps> = (props: PCovProps) => {
    // tslint:disable-next-line: max-line-length
    const [state, setState] = useState<PCovState>({ pageIndex: 0, pageSize: 10, results: { count: 0, records: [] }, isLoading: true });
    const globalState = useContext(store);
    const { dispatch } = globalState;

    useEffect(() => {
        const payload = setTimeout(() => {
            if (props.byCarrier) {
                fetch(`${process.env.REACT_APP_PCOV_BY_CARRIER_ENDPOINT}/?EmployerName=${(props.propsBase.answerValue as CoverageProps).entityName}&DateOfAccident=${(props.propsBase.answerValue as CoverageProps).policyEffectiveDate}&PageIndex=${state.pageIndex}&PageSize=${state.pageSize}&Strict=true`,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(globalState.state.appState.user && globalState.state.appState.user.state.length > 0 ? globalState.state.appState.user.state.split(',') : [])
                    }
                ).then(
                    (response) => response.json()
                        .then((json) => json as PCovSearchResultsWrapped)
                        .then((data) => {
                            // tslint:disable-next-line: max-line-length
                            setState({ ...state, isLoading: false, results: { count: data.recordsTotal, records: (data.data || []) } });
                        }),
                    (err) => handleErrorToast(`
                          An error occurred.
                          Please email web.support@njcrib.com and attach a screenshot of the current page`),
                );
            } else {
                fetch(`${process.env.REACT_APP_PCOV_ENDPOINT}/?EmployerName=${(props.propsBase.answerValue as CoverageProps).entityName}&DateOfAccident=${(props.propsBase.answerValue as CoverageProps).policyEffectiveDate}&PageIndex=${state.pageIndex}&PageSize=${state.pageSize}&Strict=true`)
                    .then(
                        (response) => response.json()
                            .then((json) => json as PCovSearchResultsWrapped)
                            .then((data) => {
                                // tslint:disable-next-line: max-line-length
                                setState({ ...state, isLoading: false, results: { count: data.recordsTotal, records: (data.data || []) } });
                            }),
                        (err) => handleErrorToast(`
              An error occurred.
              Please email web.support@njcrib.com and attach a screenshot of the current page`),
                    );
            }
        }, 499);

        return () => {
            setState({ ...state, isLoading: true });
            clearTimeout(payload);
        };
    }, [(props.propsBase.answerValue as CoverageProps).entityName, (props.propsBase.answerValue as CoverageProps).policyEffectiveDate]);

    return (
        <div className="pcovresults">
            {
                (props.propsBase.answerValue as CoverageProps).entityID === "" &&
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>
                                Employer Name (Select One)
              </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            state.results.records.length > 0 || state.isLoading ?
                                state.results.records.map((v) =>
                                    <Table.Row>
                                        <Table.Cell>
                                            <Link className="color-green" to={""}
                                                onClick={(e) => props.onChange && props.onChange(e, v.name, v.nameTabID)}>
                                                {v.name}
                                            </Link>
                                        </Table.Cell>
                                    </Table.Row>,
                                ) :
                                // tslint:disable-next-line: no-unused-expression
                                <Table.Row>
                                    <Table.Cell>
                                        <span className="color-green">
                                            {
                                                globalState.state.appState.optionChosen === PortalType.SingleEntityOwnership &&
                                                <div>
                                                    {"For assistance identifying a policy and/or employer name,"}
                                                    <br />
                                                    <b>{"please contact the Rating Division – Ownership Section at 973-622-6014 Ext. 2"}</b>
                                                </div>
                                            }
                                            {
                                                globalState.state.appState.optionChosen === PortalType.Underwriting ||
                                                globalState.state.appState.optionChosen === PortalType.Plan &&
                                                <div>
                                                    {"For assistance identifying a policy and/or employer name,"}
                                                    <br />
                                                    <b>{"please contact a CRIB Underwriter at 973-622-6014 Ext. 4"}</b>
                                                </div>
                                            }
                                            {
                                                globalState.state.appState.optionChosen === PortalType.ExperienceRating &&
                                                <div>
                                                    {"For assistance identifying a policy and/or employer name,"}
                                                    <br />
                                                    <b>{"please contact the Rating Division – Experience Rating Section at 973-622-6014 Ext. 2"}</b>
                                                </div>
                                            }
                                        </span>
                                    </Table.Cell>
                                </Table.Row>
                        }
                    </Table.Body>
                </Table>
            }
            {
                (props.propsBase.answerValue as CoverageProps).entityID !== "" &&
                <div style={{ marginTop: "30px" }}>
                    <Question isRequired={true} questionContent="Coverage ID"
                        infoMessage={"The Coverage ID is an internal CRIB identifier assigned to each entity and its related policy and rating experience."} moreInfo={true} />
                    <Form.Input readOnly required value={(props.propsBase.answerValue as CoverageProps).entityID} id={"coverageID"} />
                </div>
            }
        </div>
    );
};

export default PCovTable;
